import { v4 as uuidv4 } from 'uuid';
import DOMPurify from "dompurify";


const normalize = (value) =>
    typeof value === "string" ? value.trim() : "";

const capitalizeFirst = (word = "") =>
    word ? word.charAt(0).toUpperCase() + word.slice(1) : "";

/**
 * Capitalizes first letter of a string
 * "policy" → "Policy"
 */
export function capitalize(text = "") {
    const value = normalize(text.toLowerCase());
    return capitalizeFirst(value);
}

/**
 * Capitalizes each word (space separated)
 * "fees payments policy" → "Fees Payments Policy"
 */
export function capitalizeWords(text) {
    const value = normalize(text);
    if (!value) return "";

    return value
        .toLowerCase()
        .split(/\s+/)
        .map(capitalizeFirst)
        .join(" ");
}
/**
 * Capitalizes each word (space separated)
 * "fees payments policy" → "Fees Payments Policy"
 */
export function capitalizeWordsDash(text) {
    const value = normalize(text);
    if (!value) return "";

    return value
        .toLowerCase()
        .replace(/-/g, " ")
        .split(/\s+/)
        .map(capitalizeFirst)
        .join(" ");
}
/**
 * Capitalizes each word (space separated)
 * "fees payments policy" → "Fees Payments Policy"
 */
export function capitalizeWordsRemoveDash(text) {
    if (!text) return "";

    return String(text)
        .toLowerCase()
        .replace(/[-_]+/g, " ")
        .trim()
        .split(/\s+/)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}

/**
 * Converts slug to title
 * "fees-payments-policy" → "Fees Payments Policy"
 */
export function slugToTitle(slug) {
    return smartCapitalize(slug);
}

/**
 * Handles kebab-case, snake_case, mixed input
 * "fees_payments-policy" → "Fees Payments Policy"
 */
export function smartCapitalize(text) {
    const value = normalize(text);
    if (!value) return "";

    return value
        .replace(/[-_]/g, " ")
        .replace(/\s+/g, " ")
        .toLowerCase()
        .split(" ")
        .map(capitalizeFirst)
        .join(" ");
}
export const limitWords = (text, limit = 15) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > limit
        ? words.slice(0, limit).join(" ") + "..."
        : text;
};

/**
 * Limit text by character count
 *
 * @param {string} text
 * @param {number} limit
 * @returns {string}
 */
export const limitChars = (text = "", limit = 15) => {
    if (!text) return "";

    const normalized = text.trim();

    return normalized.length > limit
        ? normalized.slice(0, limit) + "..."
        : normalized;
};

/**
 * 
 * @returns 
 */

export const uuid = () => {
    return uuidv4();
};

/**
 * 
 * @param {*} html 
 * @returns 
 */
export const renderHTML = (html) => {
    return {
        __html: DOMPurify.sanitize(html || "")
    };
};


/**
 * 
 * @param {*} html 
 * @returns 
 */

export const orderByField = (payload) => {
  return [...payload].sort((a, b) =>
    a.name.localeCompare(b.name)
  );
};

/**
 * 
 * @param {*} html 
 * @returns 
 */
export const orderByString = (array, order = "asc") => {
  return [...array].sort((a, b) => {
    const result = a.localeCompare(b);
    return order === "asc" ? result : -result;
  });
};

/**
 * Build text
 * break line: text
 *
 * @param {string} text
 * @returns {string}
 */

export const breakLineOnComma = (text) => {
  return text.split(",").map((item, index) => (
    <span key={index}>
      {item.trim()}
      <br />
    </span>
  ));
};